// Configuración de MSAL para autenticación con Microsoft
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/common',
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  }
};

// Validar que las variables de entorno requeridas estén configuradas
if (!process.env.REACT_APP_CLIENT_ID) {
  throw new Error('REACT_APP_CLIENT_ID no está configurado en las variables de entorno');
}
if (!process.env.REACT_APP_TENANT_ID) {
  throw new Error('REACT_APP_TENANT_ID no está configurado en las variables de entorno');
}

// Configuración de los permisos requeridos (con permisos para transcripciones de SharePoint y Planner)
export const loginRequest = {
  scopes: [
    'User.Read', 
    'Calendars.Read',
    'Files.Read',
    'Files.Read.All',
    // Escritura en el OneDrive de la persona. Hace falta para subir el acta
    // generada: Word para la web abre archivos, no bytes, así que para verla
    // con su aspecto real tiene que existir en algún sitio.
    'Files.ReadWrite',
    // Y en las bibliotecas de SharePoint donde la persona ya pueda escribir,
    // que es donde se publica el acta terminada. Se elige este y no
    // `Sites.ReadWrite.All` a propósito: aquel da acceso a TODOS los sitios del
    // tenant y exige consentimiento de administrador; este no amplía lo que la
    // persona ya puede hacer, solo deja que la aplicación lo haga en su nombre.
    'Files.ReadWrite.All',
    'Sites.Read.All',
    'Tasks.ReadWrite',
    'Group.Read.All',
    // Leer la ficha basica —nombre y correo— de cualquiera del directorio, para
    // poder ofrecerlo al asignar una tarea. Se elige este y no `User.Read.All`
    // a proposito: aquel da acceso al perfil completo de todo el mundo y exige
    // consentimiento de administrador; este se queda en lo que ya aparece en la
    // libreta de direcciones de Outlook.
    'User.ReadBasic.All'
  ]
};

// Configuración para obtener el token de acceso
export const tokenRequest = {
  scopes: [
    'User.Read', 
    'Calendars.Read',
    'Files.Read',
    'Files.Read.All',
    // Escritura en el OneDrive de la persona. Hace falta para subir el acta
    // generada: Word para la web abre archivos, no bytes, así que para verla
    // con su aspecto real tiene que existir en algún sitio.
    'Files.ReadWrite',
    // Y en las bibliotecas de SharePoint donde la persona ya pueda escribir,
    // que es donde se publica el acta terminada. Se elige este y no
    // `Sites.ReadWrite.All` a propósito: aquel da acceso a TODOS los sitios del
    // tenant y exige consentimiento de administrador; este no amplía lo que la
    // persona ya puede hacer, solo deja que la aplicación lo haga en su nombre.
    'Files.ReadWrite.All',
    'Sites.Read.All',
    'Tasks.ReadWrite',
    'Group.Read.All',
    // Leer la ficha basica —nombre y correo— de cualquiera del directorio, para
    // poder ofrecerlo al asignar una tarea. Se elige este y no `User.Read.All`
    // a proposito: aquel da acceso al perfil completo de todo el mundo y exige
    // consentimiento de administrador; este se queda en lo que ya aparece en la
    // libreta de direcciones de Outlook.
    'User.ReadBasic.All'
  ],
  forceRefresh: false
};

// Configuración específica para SharePoint
export const sharepointTokenRequest = {
  scopes: [`https://${process.env.REACT_APP_SHAREPOINT_DOMAIN}/.default`],
  forceRefresh: false
};

// Validar SharePoint domain
if (!process.env.REACT_APP_SHAREPOINT_DOMAIN) {
  throw new Error('REACT_APP_SHAREPOINT_DOMAIN no está configurado en las variables de entorno');
}